export default __webpack_public_path__ + "static/media/Alaya.7cce6889.png";